import { apiClient } from '@/core/api/client';
import { Expertise } from '../types/dashboard.types';

export const dashboardAPI = {
  getDashboardExpertises: async (): Promise<{ success: boolean; data: { expertises: Expertise[] } }> => {
    return apiClient.get('/api/expert/dashboard/expertises');
  },
  
  getDashboardStats: async () => {
    return apiClient.get('/api/expert/dashboard/stats');
  }
};